'use strict';
import HubSpotClient from 'hubspot-api';
var MailingListService = /** @class */ (function () {
    function MailingListService($http, $httpParamSerializer, configurationService) {
        'ngInject';
        this.$http = $http;
        this.$httpParamSerializer = $httpParamSerializer;
        this.apiClient = new HubSpotClient({});
        this.configurationService = configurationService;
    }
    MailingListService.prototype.iterableMailingListSubscribe = function (mail) {
        var formFields = this.$httpParamSerializer({
            "email": mail
        });
        var url = "https://links.iterable.com/lists/publicAddSubscriberForm?publicIdString=" + this.configurationService.getEnvironmentConfiguration().iterablePublicIdString;
        return this.$http.post(url, formFields, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    };
    MailingListService.prototype.mailingListsSer = function (mail) {
        var formFields = { "fields": [
                {
                    "name": "email",
                    "value": mail
                }
            ] };
        try {
            return this.apiClient.forms.submitFormV3(6134447, '87e496aa-6644-4346-b2f0-dc75afb16b6f', formFields);
        }
        catch (error) {
            return error;
        }
    };
    return MailingListService;
}());
export default MailingListService;
//# sourceMappingURL=mailinglist.service.js.map